import { useEffect, useRef, useState } from 'react';
import MAP_IMG from '../../assets/images/service-map.jpg';
import ContactFormButton from '../Global/ContactFormButton';

export default function GoogleMaps() {
	return (
		<div className='bg-white'>
			<div className='mx-auto max-w-7xl px-6 lg:px-16'>
				<div className='mx-auto max-w-2xl space-y-16 divide-y divide-gray-100 lg:mx-0 lg:max-w-none'>
					{/* Google Maps Section */}
					<div className='grid grid-cols-1 gap-10 pt-16 lg:grid-cols-3'>
						<div>
							<h2 className='text-pretty text-4xl font-semibold tracking-tight text-gray-900'>
								Areas We Serve
							</h2>
							<p className='mt-4 text-base/7 text-gray-600'>
								We proudly service areas in Alabama & Northwestern Florida. If
								you are outside of our service area, please contact us to see if
								we can accommodate your needs.

							</p>
							<ContactFormButton />
						</div>
						<div className='col-span-2'>
							<img
								src={MAP_IMG}
								className='rounded-lg shadow-lg	'
								alt='Map of Service Area'
							/>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
